export const resolvePeople = ({ people }) => {
  return people;
};

export default resolvePeople;
